import { useEffect } from 'react';
import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/integrations/supabase/client';

export const useBlogView = (postId: string | undefined) => {
  const { user } = useAuth();

  useEffect(() => {
    if (!postId) return;

    const trackView = async () => {
      // Generate or get session ID
      let sessionId = sessionStorage.getItem('blog_session_id');
      if (!sessionId) {
        sessionId = crypto.randomUUID();
        sessionStorage.setItem('blog_session_id', sessionId);
      }

      // Record view
      await supabase.from('blog_views').insert({
        post_id: postId,
        user_id: user?.id || null,
        session_id: sessionId,
      });

      // Increment view count
      const { data: post } = await supabase
        .from('blog_posts')
        .select('view_count')
        .eq('id', postId)
        .single();

      if (post) {
        await supabase
          .from('blog_posts')
          .update({ view_count: (post.view_count || 0) + 1 })
          .eq('id', postId);
      }
    };

    trackView();
  }, [postId, user]);
};
